<template>
  <c-flex-layout
    align-left
    :style="{ alignItems: 'flex-start' }"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
  >
    <template #left>
      <div :style="_labelStyle">
        <div :style="{ marginRight: '.8rem' }">
          <c-icon :type="icon" />
        </div>
        <div :style="textStyle">
          {{ name }}
        </div>
      </div>
    </template>
    <template #right>
      <div :style="{ width: '100%', position: 'relative' }">
        <slot />
        <div
          v-if="loading"
          :style="{ position: 'absolute', right: '.8rem', top: `.2rem`, display: 'flex', height: '2.8rem'}"
        >
          <c-button
            v-if="hover"
            icon="close-circle"
            color="light"
            size="xs"
            :style="{ marginRight: '1rem', marginTop: '.2rem' }"
            @click="$emit('cancel-click')"
          >
            Stop
          </c-button>
          <template v-else>
            <c-icon
              type="pro"
              :color="$colors.purple.base"
            />
            <div :style="{ fontSize: $fontSizes[4], margin: '0 .4rem', color: $colors.purple.base, display: 'flex', alignItems: 'center' }">
              AI is writing...
            </div>
          </template>
          <c-icon
            type="loading"
            spin
            :color="$colors.purple.base"
          />
        </div>
      </div>
    </template>
  </c-flex-layout>
</template>

<script>
import CButton from 'shared/components/CButton.vue';
import CFlexLayout from 'shared/components/CFlexLayout.vue';
import CIcon from 'shared/components/CIcon.vue';

export default {
  name: 'PropertyItem',
  props: {
    name: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    labelStyle: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: { CButton, CFlexLayout, CIcon },
  data() {
    return { hover: false };
  },
  emits: ['cancel-click'],
  computed: {
    textStyle() {
      return {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      };
    },
    _labelStyle() {
      return {
        ...this.labelStyle,
        display: 'flex',
        alignItems: 'center',
        color: this.$colors.grey.base,
        width: '12rem',
        overflow: 'hidden',
        marginRight: '.8rem',
      };
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">

</style>
